import { Component, Output, OnInit, ElementRef, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { Observable }        from 'rxjs/Observable';
import { Subject }           from 'rxjs/Subject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { SearchService } from '../shared/search.service';
import { ContentService } from '../shared/content.service';
import { Content } from '../shared/content';
import { ConfigService } from '../shared/config.service';
import { UtilsService } from '../shared/utils.service';
import { MetaService } from '../shared/meta.service';
import { IntlService } from '../shared/intl.service';

@Component({
    template: require('./partials/content-record-edit.component.html'),
    providers: [DatePipe]
})
export class ContentRecordEditComponent extends Content implements OnInit {// 

    public action: string = 'add';
    recordForm: FormGroup;
    url: string;
    special;
    private urlSoloistLimit = 4;

    public inputFocus = {
        element: null,
        type: null
    };

    constructor (public recordConfig: ConfigService, private recordIntlService: IntlService, private recordMetaService: MetaService, public el: ElementRef, private searchService: SearchService, private datePipe: DatePipe,private utils: UtilsService, private formBuilder: FormBuilder, private router: Router, private recordService: ContentService, public recordRoute: ActivatedRoute) {
        super(recordConfig, recordIntlService, recordMetaService, recordService, recordRoute);
        this.setType('record');
    }

    buildGroupForm(isNew: boolean, content: any){
        let group = {};
        if(!isNew) 
            group['_id'] = content._id;
        group['cid'] = [content.cid,[]]; // null for new entry
        group['active'] = [isNew ? false : content.active,[]]; // not active when new
        group['type'] = [isNew ? 'reissue' : content.type,[]];
        group['reference'] = [isNew ? 'fr ' : content.reference,[
            Validators.required,
            Validators.minLength(4)
        ]];
        group['url'] = [content.url,[
            Validators.required
        ]];
        group['date'] = [this.datePipe.transform(isNew ? new Date() : content.date, 'yyyy-MM-dd'),[]];
        group['update_date'] = [isNew ? null : this.datePipe.transform(content.update_date, 'yyyy-MM-dd'),[]];
        group['original_references'] = isNew ? 
            this.formBuilder.array([null]) : 
            this.formBuilder.array(content.original_references);
        group['length'] = [content.length,[]]; // null for new entry
        group['price'] = [content.price,[
            Validators.required
        ]]; // null for new entry
        group['title'] = [content.title,[ // null for new entry
            Validators.required
        ]]; 
        group['music_pieces'] = isNew ? 
            this.formBuilder.array([this.getNewMusicPiece()])  : 
            this.formBuilder.array(this.getMusicPieceFormModel(this.content.music_pieces));
        group['cover'] = this.formBuilder.group({
            front: [isNew ? null : content.cover.front,[
                Validators.required
            ]],
            back: [isNew ? null : content.cover.back,[
                Validators.required
            ]]
        });
        group['description'] = isNew ? 
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.description);
        group['tags'] = isNew ? 
            this.formBuilder.array([null]) : 
            this.formBuilder.array(this.content.tags);
        return group;
    }

    ngOnInit() {

        this.recordRoute.params.subscribe((params: Params) => {
            
            // Need to init the form for the view, for some reason
            let group = this.buildGroupForm(true,{});
            this.recordForm = this.formBuilder.group(group);

            if(params['id']!=0) {
                this.action='update';
                this.recordService.getContent(this.type, {_id: params['id']}, true).then(response => {
                    this.content = response;
                    let group = this.buildGroupForm(false,this.content);
                    this.recordForm = this.formBuilder.group(group);
                    this.url = this.content.url;
                    // Is special
                    this.recordService.getContent('special',{url: this.url}, true).then(special => {
                        if(!special.error)
                            this.special = special;
                    });
                });
            } else {
                this.recordForm.valueChanges.subscribe(e=>{
                    this.buildUrl();
                });
            }

        });

        this.recordRoute.parent.params.subscribe((params: Params) => {
            // Current language
            this.currentLanguage = params['lg'];
        });

    }
    
    onInputChange(type, $event){
        this.inputFocus = {
            element: $event.target,
            type: type,
        };
    }

    buildUrl(){
        if(this.recordForm.get('title').value){
            let title = this.recordForm.get('title').value;
            title = this.utils.removeAccents(title);
            title = title.toLowerCase().replace(/[^a-z0-9]+/g,"-");
            let ref = this.recordForm.get('reference').value;
            ref = ref.toLowerCase().replace(/[^a-z0-9]+/g,"");
            let url = title+'-'+ref;
            url = url.replace(/--+/,"-");
            this.url = url;
        }
    }

    getMusicPieceFormModel(mps: Object[]): any {
        let mpsForm: any[] = [];
        mps.forEach((mp:any) => {
            let mpForm: FormGroup = this.formBuilder.group({});
            for(let key in mp) {
                if (key == 'soloists') {
                    let soloistsForm: any[] = [];
                    mp[key].forEach((sol:any) => {
                        soloistsForm.push(this.formBuilder.group(sol));
                    });
                    mpForm.addControl(key,this.formBuilder.array(soloistsForm));
                } else if (typeof mp[key] === 'string' || mp[key] == null) {

                    mpForm.addControl(key,this.formBuilder.control(mp[key]));
                }
            }
            mpsForm.push(mpForm);
        });
        return mpsForm;
    }

    getNewMusicPiece(): FormGroup {
        return this.formBuilder.group({
                    title: [null,[
                        Validators.required
                    ]],
                    composer: [null,[]],
                    conductor: [null,[]],
                    orchestra: [null,[]],
                    date: ['1900-01-01',[]],
                    soloists: this.formBuilder.array([this.getNewSoloist()]),
        });
    }

    getNewSoloist(): FormGroup {
        return this.formBuilder.group({
                    name: [null,[]],
                    instrument: [null,[]]
        });
    }

    onSubmit(){
        // update date
        this.recordForm.controls['update_date'].setValue(this.datePipe.transform(new Date(), 'yyyy-MM-dd'));
        // save
        this.recordService.saveContent('record', this.action, this.recordForm.value).then(res =>{
            // console.log('form', this.recordForm.value);
            // this.router.navigate(['records'], {relativeTo: this.route.parent});
            this.router.navigate(['records/reload'], {relativeTo: this.route.parent});
            setTimeout(() => {
                this.router.navigate(['records'], {relativeTo: this.route.parent});
            }, 500);  
        })
    }

    onAddTag () {
        let tags = this.recordForm.controls['tags'] as FormArray;
        tags.push(this.formBuilder.control(null));
    }
    onRemoveTag(index: any){
        let tags = this.recordForm.controls['tags'] as FormArray;
        tags.removeAt(index);
    }

    onAddOriginalReference () {
        let original_references = this.recordForm.controls['original_references'] as FormArray;
        original_references.push(this.formBuilder.control(null));
    }

    onRemoveOriginalReference(index: any){
        let original_references = this.recordForm.controls['original_references'] as FormArray;
        original_references.removeAt(index);
    }

    onAddMusicPiece () {
        let mps = this.recordForm.controls['music_pieces'] as FormArray;
        mps.push(this.getNewMusicPiece());
    }
    onRemoveMusicPiece(index: any){
        let mps = this.recordForm.controls['music_pieces'] as FormArray;
        mps.removeAt(index);
    }

    onAddSoloist (mpIndex: any) {
        let sols = (<FormArray>this.recordForm
                        .get('music_pieces')).at(mpIndex)
                        .get('soloists') as FormArray;
        sols.push(this.getNewSoloist());
    }
    onRemoveSoloist(mpIndex: any, solIndex: any){
        let sols = (<FormArray>this.recordForm
                        .get('music_pieces')).at(mpIndex)
                        .get('soloists') as FormArray;
        sols.removeAt(solIndex);
    }

    keyupEditorHandlerFunction(fieldPath: string[], text: string){
        this.recordForm.get(fieldPath).patchValue(text);
        //console.log(text);
    }

    public deleteContent(type: string, id: string){ 
        this.recordService.deleteContent(type,id);
        this.router.navigate(['records/reload'], {relativeTo: this.route.parent});
        setTimeout(() => {
            this.router.navigate(['records'], {relativeTo: this.route.parent});
        }, 500);  
    }

} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-record-edit.component.ts